// Local photos under /public/images/real and /public/images/news are
// pre-converted to .avif/.webp (see scripts/optimize-images.mjs).
// Remote/placeholder URLs are left as-is.
export const isLocalPhoto = (src) =>
  typeof src === "string" && (src.startsWith("/images/real/") || src.startsWith("/images/news/"));

export const avifSrc = (src) => src.replace(/\.jpe?g$/i, ".avif");
export const webpSrc = (src) => src.replace(/\.jpe?g$/i, ".webp");
